import React from 'react';
// Embeds the Delve Trust Center in a full-screen iframe with an overlay to hide branding

export function App() {
  return <div className="relative w-full h-screen overflow-hidden" data-id="element-0">
      <iframe src="https://trust.delve.co/magic-patterns" className="w-full h-full border-0" title="Delve Trust" allow="clipboard-write" data-id="element-1" />
      {/* Overlay to hide the Delve branding link at the bottom */}
      <div className="absolute bottom-0 left-0 w-full h-32 bg-white pointer-events-none" style={{
      zIndex: 10
    }} data-id="element-2" />
    </div>;
}